/*
 * fake reactive value observed by computed properties that need to observe non-reactive properties
 */

import { cyclical_increment } from '@vaaas/fpts/maths';
import { ref } from 'vue';

/** the way force refresh works is by incrementing a number
 *
 * since the number changes, vue detects that an update must happen
 */
const counter = ref(-Number.MAX_SAFE_INTEGER);

/** increments the counter, but when it reaches the maximum safe value, it loops back to the lowest safe value
 *
 * this because of accuracy problems with Javascript numbers, which are floating point, not integers
 *
 * @see https://en.wikipedia.org/wiki/Floating-point_arithmetic#Accuracy_problems
 */
const up = cyclical_increment(-Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER);

/** call this function in computed properties that you want to force refresh every frame
 *
 * it returns a number that can be used as a key, indicating the current refresh iteration
 */
export function enable_force_refresh(): number {
    return counter.value;
}

/** force refresh all components that have enabled force refreshes */
export function force_refresh(): number {
    return counter.value = up(counter.value);
}
